module.exports = function getResource(label, vars = []) {
    const resources = {
        canadaLegalCopy:
            'Sephora Beauty Canada, Inc. (600 de Maisonneuve Boulevard West, Suite 2400, Montréal, Quebec, H3A 3J2, sephora.ca) is requesting consent on its own behalf and on behalf of Sephora USA, Inc. (525 Market Street, Floor 32, San Francisco, CA 94105, sephora.com). You may withdraw your consent at any time.',
        prop65Msg: 'This item is restricted from shipping to California addresses.',
        comingSoon: 'Coming Soon',
        availableInStoreOnly: 'Available in Store Only',
        soldOut: 'Sold Out',
        outOfStock: 'Out of Stock',
        emailWhenInStock: 'Notify Me When Available',
        removeReminder: 'Manage Notifications'
    };

    return resources[label];
};
